import { useEffect, useRef } from "react";
import { Game } from "../game/engine";
import { W, H, STEP } from "../game/world";
import { STRINGS } from "../i18n";

const KEYMAP = {
  ArrowLeft: "left", KeyA: "left",
  ArrowRight: "right", KeyD: "right",
  ArrowUp: "up", KeyW: "up",
  ArrowDown: "down", KeyS: "down",
  KeyE: "mark", KeyC: "mark",
  Space: "jump",
};

export const GameCanvas = ({ seed, level, running, onStats, onEnd, inputRef, touch, lang }) => {
  const canvasRef = useRef(null);
  const gameRef = useRef(null);
  const cbs = useRef({});
  const levelRef = useRef(level);
  levelRef.current = level;
  cbs.current = { onStats, onEnd };

  useEffect(() => {
    const g = new Game({
      onStats: (s) => cbs.current.onStats(s),
      onEnd: (t, s) => cbs.current.onEnd(t, s),
    });
    gameRef.current = g;
    if (inputRef) inputRef.current = (k, down) => g.press(k, down);
    const ctx = canvasRef.current.getContext("2d");
    let raf;
    let last = performance.now();
    let acc = 0;
    const loop = (now) => {
      acc += Math.min(100, now - last);
      last = now;
      while (acc >= STEP) {
        g.update();
        acc -= STEP;
      }
      g.render(ctx);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const handle = (down) => (e) => {
      if (e.target.tagName === "INPUT") return;
      const k = KEYMAP[e.code];
      if (!k) return;
      e.preventDefault();
      g.press(k, down);
    };
    const kd = handle(true);
    const ku = handle(false);
    window.addEventListener("keydown", kd);
    window.addEventListener("keyup", ku);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("keydown", kd);
      window.removeEventListener("keyup", ku);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    gameRef.current.prompt = STRINGS[lang].doorPrompt[touch ? "touch" : "keys"];
  }, [lang, touch]);

  useEffect(() => {
    if (seed > 0) gameRef.current.reset(levelRef.current);
  }, [seed]);

  useEffect(() => {
    const g = gameRef.current;
    g.paused = !running;
    if (!running) g.keys = {};
  }, [running]);

  return <canvas ref={canvasRef} width={W} height={H} className="game-canvas" data-testid="game-canvas" />;
};
